import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LabeledInput from "Root/quiz/elements/labeledInput/input";
import MetricsBtn from "Root/components/metricsBtn/index";
import styles from "./weight.module.scss";
const WeightComponent = (props) => {
    const { setValue } = props;
    return (_jsx("div", { className: styles.weight_container, children: _jsxs("div", { className: styles.row, children: [_jsxs("div", { className: styles.title_btn, children: [_jsx("span", { children: "Weight" }), !props.hideMetrics && _jsx(MetricsBtn, { metrics: props.metrics, setMetrics: props.setMetrics })] }), _jsx(LabeledInput, { max: props.metrics ? 272 : 600, min: props.metrics ? 23 : 50, maxLength: 3, value: props.value, rightLabel: props.metrics ? "KG" : "LBS", setValue: setValue })] }) }));
};
export default WeightComponent;
